import { ImportUserParams } from '../../../services/identity/identity.types';
import { FORM_FIELDS } from '../../../constants';
import { removeUndefined } from '../../../helpers';

export const getParamsForAuth = (formData: FE.FormData): ImportUserParams => {
    const {
        [FORM_FIELDS.FIRST_NAME]: firstName,
        [FORM_FIELDS.LAST_NAME]: lastName,
        [FORM_FIELDS.EMAIL]: email,
        [FORM_FIELDS.PHONE]: phone,
    } = formData;

    return removeUndefined({
        phone: phone.replace(/\D/g, ''),
        firstName,
        lastName,
        email,
    });
};
